import { render, staticRenderFns } from "./NestedMenu.vue?vue&type=template&id=ddc02ed4&scoped=true"
import script from "./NestedMenu.vue?vue&type=script&lang=js"
export * from "./NestedMenu.vue?vue&type=script&lang=js"
import style0 from "./NestedMenu.vue?vue&type=style&index=0&id=ddc02ed4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc02ed4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MenuItem: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/MenuItem.vue').default})
